import React, {ReactElement} from 'react';
import numeral from 'numeral';
import Card from '@mui/material/Card';
import Skeleton from '@mui/material/Skeleton';

import Tooltip from '../CustomTooltip';
import ComparisonArrow from './ComparisonArrow';
import InfoIcon from '../../assets/icons/infosmall.svg';

import './index.scss';

export type AnalyticsTotalCardProps = {
  format: string;
  title: string;
  current: number;
  previous: number;
  tooltipText?: string;
  topColor?: string;
  loading?: boolean;
};

const AnalyticsTotalCard = ({
  format,
  title,
  current,
  previous,
  tooltipText,
  topColor,
  loading
}: AnalyticsTotalCardProps): ReactElement => {
  const borderTopStyle = (_topColor: string) => {
    return topColor ? {borderTop: `5px solid ${_topColor}`} : {};
  };

  const cardStyle = () => {
    return {
      border: 'none',
      ...borderTopStyle(topColor),
      height: '100px'
    };
  };

  const renderPlaceholder = () => {
    return (
      <Card sx={cardStyle()} className="analytics-total-card">
        <div className="contents">
          <Skeleton variant="rectangular" width={100} />
          <h3>
            <Skeleton variant="rectangular" width={50} />
          </h3>
        </div>
      </Card>
    );
  };
  return loading ? (
    renderPlaceholder()
  ) : (
    <Card sx={cardStyle()} className="analytics-total-card">
      <div className="contents">
        <small>{title}</small>
        {tooltipText && (
          <Tooltip title={tooltipText} arrow placement="bottom-start">
            <span className="info-icon">
              <img src={InfoIcon} alt="Info" />
            </span>
          </Tooltip>
        )}
        <h3>
          {numeral(current).format(format)}
          {current !== previous && (
            <ComparisonArrow current={current} previous={previous} />
          )}
        </h3>
      </div>
    </Card>
  );
};

AnalyticsTotalCard.defaultProps = {
  topColor: 'rgb(30, 57, 210)',
  tooltipText: null,
  loading: false
};

export default AnalyticsTotalCard;
